<template>
    <b-modal
        :ref="modalRef"
        title-tag="h2"
        :title="'Apply Discount'"
        lazy
        no-close-on-backdrop
        no-close-on-esc
        @shown="shown"
    >
        <form @submit.prevent>
            <div v-if="warningMessagePayment">
                <div class="alert-wrapper">
                    <div
                        class="alert alert-warning alert-dismissible"
                        role="alert"
                    >
                        {{ warningMessagePayment }}
                    </div>
                </div>
            </div>

            <b-alert :show="showAlert" variant="danger">
                <i class="cus-exclamation"></i>
                {{ alertMessage }}
            </b-alert>

            <b-form-group label-for="discount" label="Discount:" label-cols="4">
                <vet-select-discount
                    id="discount"
                    ref="vselectdiscount"
                    v-model="selectedDiscount"
                    placeholder="Discount (required)"
                    :class="{ 'border-danger': errors.has('discount') }"
                    name="discount"
                    module="discount"
                />
            </b-form-group>
        </form>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                :is-disabled="isHasUsersChooseInvoice"
                ok-title="Apply"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import InvoiceService from "@/services/invoice";
import EstimateService from "@/services/estimate";
import vetSelectDiscount from "@/module/commons/vet-select-discount.vue";

export default {
    components: {
        vetSelectDiscount,
        modalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalRef: {
            type: String,
            required: true
        },
        invoiceId: {
            type: String,
            default: null
        },
        estimateId: {
            type: String,
            default: null
        }
    },
    computed: {
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.invoiceId
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.invoiceId
                  )
                : "";
        }
    },
    data() {
        return {
            isLoading: false,
            selectedDiscount: null,
            discounts: [],
            showAlert: false,
            alertMessage: ""
        };
    },
    methods: {
        open() {
            this.$refs[this.modalRef].show();
        },
        shown() {
            this.$refs["vselectdiscount"].focus();
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        },
        async save() {
            let valid = await this.$validator.validateAll();
            if (!valid) {
                return false;
            }

            this.showAlert = false;
            this.alertMessage = "";
            this.isLoading = true;

            try {
                // PRE-APPLY, to check whether the discount can be applied to the invoce/estimate item listed
                let params = {
                    invoice_id: this.invoiceId,
                    estimate_id: this.estimateId,
                    discount_id: this.selectedDiscount.value,
                    is_save: false
                };
                let responsePreApply = this.invoiceId
                    ? await InvoiceService.applyDiscount(params)
                    : await EstimateService.applyDiscount(params);

                if (responsePreApply && !responsePreApply.continue) {
                    this.showAlert = true;
                    this.alertMessage = responsePreApply.message;
                    this.isLoading = false;
                    return;
                }

                // PROCEED SAVE: the discount can be applied
                params.is_save = true;
                let response = this.invoiceId
                    ? await InvoiceService.applyDiscount(params)
                    : await EstimateService.applyDiscount(params);

                if (response) {
                    if (response.is_warning == true) {
                        this._message(response.message, "warning");
                    } else {
                        this._message(response.message || "Applied discount");
                    }
                    this.$emit("reload");
                    this.close();
                } else {
                    throw "Error";
                }
            } catch {
                this.isLoading = false;
                this._message("Error : Unable to apply discount", "danger");
            }
        }
    }
};
</script>
